(ns kyber.components.composite.dropdown-menu
  (:require [reagent.core :as reagent]
            [applied-science.js-interop :as j]
            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.components.base.button :as button]
            [kyber.components.base.link :as link]
            [kyber.i18n.core :as i18n]))

(def menu-margin 8)

(def classes
  (styles->classes
   {:container
    {:position :relative}

    :menu
    {:position :absolute
     :background-color (gs [:colors :true-white])
     :box-shadow (gs [:shadows :shadow-12])
     :border-radius (gs [:radius :r3])
     :padding [(gs [:spacing :p8])
               (gs [:spacing :p0])]}

    :link-item
    {:padding [(gs [:spacing :p8])
               (gs [:spacing :p16])]
     :display :block
     :width "100%"
     :text-align :left

     "&:hover"
     {:background (gs [:colors :gray-scale-100])}}
    
    :divider
    {:border-top (str "1px solid " (gs [:colors :gray-scale-200]))
     :margin [(gs [:spacing :p8])
              (gs [:spacing :p0])]}}))

(defn link-item
  [{:keys [href display]}]
  [link/link {:class (:link-item classes)
              :href href
              :role "menuitem"}
   display])

(defn divider []
  [:div {:class (:divider classes)}])

(defn button-link-item
  [{:keys [on-click display]}]
  [button/button-link
   {:class (:link-item classes)
    :role "menuitem"
    :on-click on-click}
   display])

(defn render
  [{:keys [trigger styles position body]
    :or {position :bottom-right}}]
  (let [open? (reagent/atom false)
        on-window-click #(when @open? (reset! open? false))
        trigger-ref! (atom nil)
        trigger-height (atom nil)]
    (reagent/create-class
     {:component-did-mount
      #(do (j/call js/window :addEventListener "click" on-window-click)
           (reset! trigger-height
                   (-> @trigger-ref!
                       (j/call :getBoundingClientRect)
                       (j/get :height))))

      :component-will-unmount
      #(j/call js/window :removeEventListener "click" on-window-click)

      :reagent-render
      (fn []
        [:div (cond-> {:class [(:container classes)
                               (get classes position)]}
                (some? styles)
                (assoc :style styles))
         [:div (cond-> {:ref        #(reset! trigger-ref! %)
                        :role "button"
                        :aria-haspopup "menu"
                        :aria-expanded (str @open?)
                        :aria-label (i18n/t* ::aria-label)
                        :on-click   #(do
                                       (.stopPropagation %)
                                       (swap! open? not))}
                 (not @open?) (assoc :class "cooltipz--left"))
          trigger]
         (when (true? @open?)
           [:div {:class (:menu classes)
                  :role "menu"
                  :style (cond-> {}
                           (get #{:top-left :top-right} position)
                           (assoc :bottom (+ menu-margin @trigger-height))

                           (get #{:bottom-left :bottom-right} position)
                           (assoc :top (+ menu-margin @trigger-height))

                           (get #{:bottom-right :top-right} position)
                           (assoc :right 0)

                           (get #{:bottom-left :top-left} position)
                           (assoc :left 0))}
            body])])})))
